import React from 'react';
import CustomerAgreement from '../components/CustomerAgreement';

const EulaPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto space-y-8">
        <div>
          <h1 className="text-center text-3xl font-bold text-gray-900 dark:text-white">
            Aivilo Lens Customer Agreement
          </h1>
          <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
            Effective Date: Upon Customer&apos;s acceptance
          </p>
          <p className="text-center text-sm text-gray-600 dark:text-gray-400">
            Version: 1.4 | Last Updated: January 29, 2026
          </p>
        </div>

        <CustomerAgreement />

        <div className="text-center text-sm text-gray-500 dark:text-gray-400">
          <p>
            Questions about this agreement? Contact us at{' '}
            <a href="mailto:legal@aivilo.ai" className="text-blue-600 dark:text-blue-400 hover:underline">
              legal@aivilo.ai
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EulaPage;
